/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { LinksListComponentDisplay } from "cms/components/components/links-list/display";
import { LinksListComponentEdit } from "cms/components/components/links-list/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

const LinksListComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <LinksListComponentDisplay />,
        editComponent: <LinksListComponentEdit />,
    };
    return getComponentZoneLayout(zoneProps);
};

LinksListComponent.displayName = "LinksListComponent";
export { LinksListComponent };
